import { createContext } from 'react';

export const HistogramInfiniteZoomContext = createContext<boolean>(false);

HistogramInfiniteZoomContext['displayName'] = 'HistogramInfiniteZoomContext';
